import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InjectedAuthRouterProps } from 'redux-auth-wrapper/history4/redirect';

import * as App from '../../../../common/services/app/';
import { AppActionPropTypes, PingData } from '../../../../common/services/app/Types';
import { ConfigProp, IsReadyToRenderProp, RenderPropWithProps } from '../../../../common/types/prop-types/common';

import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common/';
import { AppThunkDispatch } from '../../../common/types';

export interface AuthWrapperProps extends IsReadyToRenderProp, ConfigProp {}

export interface AuthWrapperContainerProps extends InjectedAuthRouterProps {
}

interface ReduxStateProps {
    pingData: PingData;
}

interface ReduxDispatchProps {
    appServiceActions: App.Service.ServiceActions;
    appActions: typeof App.Actions;
}

class AuthWrapperContainer extends Component<
    AuthWrapperContainerProps &
    RenderPropWithProps<AuthWrapperProps> &
    ReduxStateProps &
    ReduxDispatchProps
> {
    public static propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
        isAuthenticating: PropTypes.bool.isRequired,
        redirectPath: PropTypes.any.isRequired,
        redirect: PropTypes.func.isRequired,
        pingData: PropTypes.shape({
            pingResult: PropTypes.bool.isRequired,
        }).isRequired,
        appServiceActions: App.Service.ServiceActionPropTypes.isRequired,
        appActions: AppActionPropTypes.isRequired,
        children: PropTypes.func.isRequired,
    };

    public async componentDidMount() {
        await this.props.appActions.updateConfig(config);
        await this.props.appServiceActions.ping();
        await this.props.appServiceActions.logClientInfo();
    }

    public isReadyToRender(): boolean {
        return this.props.pingData.pingResult !== undefined && this.props.pingData.pingResult; // TODO: && this.props.authStateRoles.length > 0;
    }

    public render() {
        return this.props.children({
            isReadyToRender: this.isReadyToRender(),
            config,
        });
    }
}

const mapStateToProps = (store: RootState) => ({
    pingData: store.appState.ping.data,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    appActions: bindActionCreators(App.Actions, dispatch),
    appServiceActions: App.Service.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthWrapperContainer);
